var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) { return (_pushScopeId("data-v-470a349a"), n = n(), _popScopeId(), n); };
var _hoisted_1 = { class: "content-wrapper" };
var _hoisted_2 = { key: 0 };
var _hoisted_3 = { key: 0 };
var _hoisted_4 = { class: "map-footer" };
import { computed, onBeforeUnmount, onMounted, ref, watch } from 'vue';
import { useStore } from 'vuex';
import { key } from '../../../store';
import { DEFAULT_MAP_CENTER, DEFAULT_MAP_ZOOM, DEFAULT_MAP_OPTIONS } from './mapMarkerConfig';
export default /*#__PURE__*/ _defineComponent({
    __name: 'GenericMapView',
    props: {
        mapMarkerCoordinates: {
            type: Array,
            default: function () { return []; },
        },
        showMapMarkerBounds: {
            type: Boolean,
            default: false,
        },
    },
    setup: function (__props) {
        var _this = this;
        var props = __props;
        var store = useStore(key);
        var googleApi = ref();
        var map = ref();
        var mapCenter = ref(DEFAULT_MAP_CENTER);
        var mapRef = ref();
        var mapMarkerBoundsAreChanging = ref(false);
        var mapMarkerBoundsListener = ref();
        var isMapReady = computed(function () { return !!(googleApi.value && map.value); });
        var mapMarkerBounds = computed(function () {
            if (googleApi.value !== undefined) {
                var bounds_1 = new googleApi.value.maps.LatLngBounds();
                var allMarkerCoordinates = props.mapMarkerCoordinates || [];
                allMarkerCoordinates.forEach(function (coordinates) {
                    if (coordinates && coordinates.lat && coordinates.lng) {
                        var newItem = new googleApi.value.maps.LatLng(coordinates.lat, coordinates.lng);
                        bounds_1.extend(newItem);
                    }
                });
                return !bounds_1.isEmpty() ? bounds_1 : null;
            }
            return null;
        });
        onMounted(function () { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, initializeMap()];
                case 1: return [2 /*return*/, _a.sent()];
            }
        }); }); });
        watch(mapMarkerBounds, function (newBounds) { return fitAndPanToNewMapBounds(newBounds); });
        onBeforeUnmount(function () { var _a; return (_a = mapMarkerBoundsListener.value) === null || _a === void 0 ? void 0 : _a.remove(); });
        var initializeMap = function () { return __awaiter(_this, void 0, void 0, function () {
            var _a, _b;
            var _c, _d;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        _a = map;
                        return [4 /*yield*/, ((_c = mapRef.value) === null || _c === void 0 ? void 0 : _c.$mapPromise)];
                    case 1:
                        _a.value = _e.sent();
                        _b = googleApi;
                        return [4 /*yield*/, ((_d = mapRef.value) === null || _d === void 0 ? void 0 : _d.$gmapApiPromiseLazy())];
                    case 2:
                        _b.value = _e.sent();
                        googleApi.value.maps.event.addListenerOnce(map.value, 'idle', addMapBoundsListener);
                        return [2 /*return*/];
                }
            });
        }); };
        var fitAndPanToNewMapBounds = function (newBounds) {
            if (store.state.map.fitAndPanToBounds && googleApi.value && map.value && newBounds) {
                mapMarkerBoundsAreChanging.value = true;
                mapCenter.value = newBounds.getCenter();
                map.value.fitBounds(newBounds);
                map.value.panToBounds(newBounds);
                googleApi.value.maps.event.addListenerOnce(map.value, 'idle', function () {
                    store.commit('map/setFitAndPanToBounds', false);
                    mapMarkerBoundsAreChanging.value = false;
                });
            }
        };
        var addMapBoundsListener = function () {
            var _a;
            mapMarkerBoundsListener.value = (_a = map.value) === null || _a === void 0 ? void 0 : _a.addListener('bounds_changed', function () {
                if (!mapMarkerBoundsAreChanging.value) {
                    store.commit('map/setFitAndPanToBounds', false);
                }
            });
        };
        return function (_ctx, _cache) {
            var _component_GMapRectangle = _resolveComponent("GMapRectangle");
            var _component_GMapMap = _resolveComponent("GMapMap");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_component_GMapMap, {
                    ref_key: "mapRef",
                    ref: mapRef,
                    center: mapCenter.value,
                    class: "generic-map",
                    zoom: _unref(DEFAULT_MAP_ZOOM),
                    options: _unref(DEFAULT_MAP_OPTIONS)
                }, {
                    default: _withCtx(function () { return [
                        (isMapReady.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                                _renderSlot(_ctx.$slots, "map-markers"),
                                (props.showMapMarkerBounds)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                                        _createVNode(_component_GMapRectangle, { bounds: mapMarkerBounds.value }, null, 8 /* PROPS */, ["bounds"])
                                    ]))
                                    : _createCommentVNode("v-if", true)
                            ]))
                            : _createCommentVNode("v-if", true)
                    ]; }),
                    _: 3 /* FORWARDED */
                }, 8 /* PROPS */, ["center", "zoom", "options"]),
                _createElementVNode("div", _hoisted_4, [
                    _renderSlot(_ctx.$slots, "map-footer-content")
                ])
            ]));
        };
    }
});
